import { useState, useEffect } from 'react'
import {  deleteTestimonialId, getAllTestimonials } from './../../../../../api'

function Testimonals({ openForm }){

  const [allTestimonialData, setAllTestimonialData] = useState([])
  useEffect(async () => {
    const response = await getAllTestimonials();
    console.log("Red", response.data)
    setAllTestimonialData(response.data.allTestimonials)
  },[])

  const handleDelete = async (event, testimonalId) => {
    event.preventDefault()
    event.target.disabled = true

    try {
      const { data } = await deleteTestimonialId(testimonalId)
      if (data.success && allTestimonialData) {
        const newTestimonialData = allTestimonialData.filter(testimonial => testimonial._id !== data.testi._id)
        setAllTestimonialData(newTestimonialData)
        event.target.disabled = false
      } else {
        // Send Error Message
        event.target.disabled = false
      }
    } catch (err) {
      console.log(err)
      event.target.disabled = false
    }

  }

  const handleEdit = async (testimonialId, testimonialData) => {
    // const { data } = await editJob(jobId, jobData)
    // console.log("Edited Data:", data)
    console.log("Editing:", testimonialId)
    testimonialData._id = testimonialId
    openForm({ testimonialData })
  }

  return(
    <>
      <h2>Testimonals</h2>
      <div className="table__container">
        <table className="table">
          <tr  className="table__header">
            <th>SI No</th>
            <th>Name</th>
            <th>Location</th>
            <th>Description</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
          {allTestimonialData.map((data, index)=>(
            <tr className="table__row" key={index}>
              <td>{index}</td>
              <td>{data.name}</td>
              <td>{data.location}</td>
              <td className="width-min">{data.description}</td>
              <td><button onClick={(e) => handleEdit(data._id, data)}>edit</button></td>
              <td><button onClick={(e) => handleDelete(e, data._id)}>delete</button></td>
            </tr>
          ))}
        </table>
      </div>
    </>
  )
}

export default Testimonals
